<template lang="pug">
    div.overlay(:style="backgroundColor")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            mood: VueTypes.number.def(0)
        },
        computed: {
            /**
             * Update background opacity based on mood prop.
             * @returns {{background: string}}
             */
            backgroundColor() {
                return {
                    background: `rgba(2, 35, 65, ${0.7 - this.mood * 0.0065})`
                };
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .overlay
        z-index: 2
        position: absolute
        width: 100%
        height: 100%
</style>
